export default "__VITE_ASSET__0f6ca963__"